import React, { useState, useEffect } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { TextField, ThemeProvider } from "@mui/material";
import { orangeTheme } from './theme'; // import your theme


const DateTimeRangePicker24Hr = ({ formData, setFormData, errors, IsDisabled }) => {
    const today = new Date();
    const [initialDate, setInitialDate] = useState(today);
    const [meetingDate, setMeetingDate] = useState(null);
    const [startTime, setStartTime] = useState("00:00");
    const [endTime, setEndTime] = useState("00:00");
    const [isInitialized, setIsInitialized] = useState(false); // ✅ NEW

    // ✅ Initialize state from formData ONCE
    useEffect(() => {
        if (formData && !isInitialized) {
            if (formData.meetingDate) {
                setMeetingDate(new Date(formData.meetingDate));
            } else {
                setMeetingDate(today);
            }
            if (formData.meetingStartTime) setStartTime(formData.meetingStartTime);
            if (formData.meetingEndTime) setEndTime(formData.meetingEndTime);
            setIsInitialized(true); // ✅ Mark as initialized
        }
    }, [formData, isInitialized]);

    // ✅ Update parent ONLY when local state changes (not on formData changes)
    useEffect(() => {
        if (isInitialized && meetingDate) {
            setFormData((prev) => ({
                ...prev,
                meetingDate: moment(meetingDate).format("YYYY-MM-DD"),
                meetingStartTime: startTime,
                meetingEndTime: endTime,
            }));
        }
    }, [meetingDate, startTime, endTime, isInitialized]); // ✅ Removed setFormData from deps

    const handleTimeChange = (newValue, type) => {
        const timeStr = newValue ? dayjs(newValue).format("HH:mm") : "00:00";
        if (type === "start") setStartTime(timeStr);
        if (type === "end") setEndTime(timeStr);
    };

    return (
        formData && (
            <div className="row">
                <ThemeProvider theme={orangeTheme}>
                    <div className="mb-6 col-md-4 meeting-input">
                        <label>Meeting Date<span style={{ color: 'red' }}>*</span></label>
                        <br />
                        <DatePicker
                            selected={meetingDate}
                            onChange={(date) => {
                                if (date) {
                                    setMeetingDate(date);
                                }
                            }}
                            dateFormat="dd/MM/yyyy"
                            className="form-control custom-datepicker"
                            placeholderText="dd/MM/YYYY"
                            minDate={initialDate}
                            disabled={IsDisabled}
                        />
                        {!IsDisabled && errors?.meetingDate && <div className="text-danger">{errors.meetingDate}</div>}
                        {!IsDisabled && errors?.meetingStartTime && <div className="text-danger">{errors.meetingStartTime}</div>}
                        {!IsDisabled && errors?.meetingEndTime && <div className="text-danger">{errors.meetingEndTime}</div>}
                    </div>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="mb-3 col-md-4 time-field">
                            <label>Start Time</label>
                            <TimePicker
                                value={dayjs(`1970-01-01T${startTime}`)}
                                onChange={(newValue) => handleTimeChange(newValue, "start")}
                                ampm={false}
                                className="form-control"
                                disabled={IsDisabled}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                        </div>

                        <div className="mb-3 col-md-4 time-field">
                            <label>End Time</label>
                            <TimePicker
                                value={dayjs(`1970-01-01T${endTime}`)}
                                onChange={(newValue) => handleTimeChange(newValue, "end")}
                                ampm={false}
                                className="form-control"
                                disabled={IsDisabled}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                        </div>
                    </LocalizationProvider>
                </ThemeProvider>
            </div>
        )
    );
};

export default DateTimeRangePicker24Hr;
